import { z } from "zod";

import { CONCEPT_MAX_LENGTH } from "../constants/payoutBatches.constants";

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** `ISO3:RAIL`, one choice card per corridor — `COL:BREB`, `BRA:PIX`. */
export const CORRIDOR_VALUE_PATTERN = /^[A-Z]{3}:[A-Z_]+$/;

export const corridorValue = (country: string, rail: string): string => `${country}:${rail}`;

export function splitCorridor(value: string): { country: string; rail: string } | null {
  if (!CORRIDOR_VALUE_PATTERN.test(value)) return null;
  const [country, rail] = value.split(":");
  return { country, rail };
}

export interface BatchSetupSchemaOptions {
  /** INTERNAL staff act on behalf of an organization; members are pinned server-side and send none. */
  requireOrganization: boolean;
  messages: {
    organizationRequired: string;
    walletRequired: string;
    corridorRequired: string;
    fileRequired: string;
  };
}

export function buildBatchSetupSchema({ requireOrganization, messages }: BatchSetupSchemaOptions) {
  return z.object({
    organizationId: requireOrganization
      ? z.string().regex(UUID_PATTERN, messages.organizationRequired)
      : z.string().optional(),
    sourceCurrency: z.string().min(3, messages.walletRequired).max(5),
    corridor: z.string().regex(CORRIDOR_VALUE_PATTERN, messages.corridorRequired),
    concept: z.string().trim().max(CONCEPT_MAX_LENGTH).optional(),
    file: z.custom<File>((value) => value instanceof File, {
      message: messages.fileRequired,
    }),
  });
}

export type BatchSetupValues = z.infer<ReturnType<typeof buildBatchSetupSchema>>;
